import { useEffect } from 'react';

let locks = 0;
let previousOverflow = '';
let previousPadding = '';

/** Shared lease: closing one overlapping dialog must not unlock the others. */
export function useBodyScrollLock(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    if (locks++ === 0) {
      previousOverflow = document.body.style.overflow;
      previousPadding = document.body.style.paddingRight;
      const scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      document.body.style.overflow = 'hidden';
      if (scrollbar > 0) {
        const current = Number.parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.paddingRight = `${current + scrollbar}px`;
      }
    }
    return () => {
      if (--locks === 0) {
        document.body.style.overflow = previousOverflow;
        document.body.style.paddingRight = previousPadding;
      }
    };
  }, [enabled]);
}
